import { isArrayInArray } from "lib/utils";
import { useCurrentUser } from "../users/useCurrentUser";
import { useBuyerLists } from "./useBuyerLists";

/**
 * Whether every one of these buyers is already in a list the save drawer offers. A button can
 * stand for several buyers, so it only reads as saved once they all are — and an empty selection
 * never counts as saved.
 */
export function useAllBuyersSaved(buyerGuids: string[]) {
  const { data: currentUser } = useCurrentUser();
  const { data: buyerLists, isLoading } = useBuyerLists("create_buyer_list_entries", {
    enabled: !!currentUser,
  });

  const savedGuids = (buyerLists?.all ?? []).flatMap((list) => list.entries.map((e) => e.id));

  return {
    allSaved: buyerGuids.length > 0 && isArrayInArray(buyerGuids, savedGuids),
    isLoading,
  };
}
